import React from 'react';
import PropTypes from 'prop-types';
import DayPicker, { DateUtils } from 'react-day-picker';
import DatepickerNavigation from './DatepickerrNavigation/DatepickerNavigation';
import { localeUtils } from '../DatePickers/utils/helper';
import 'react-day-picker/lib/style.css';
import '@dtsl/css-datepicker/dist/index.css';
function Datepicker(props) {
  const {
    selectedDays = undefined,
    locale = 'en',
    visible = true,
    modifiers = null,
    className = '',
    disabledDays = [],
    numberOfMonths = 1,
    showOutsideDays = true,
    onDayMouseEnter = () => {},
    month = new Date()
  } = props;
  if (!visible) {
    return null;
  }
  const handleDayClick = (day, config, event) => {
    const {
      onSelect
    } = props;
    onSelect(day, {
      ...config,
      DateUtils
    }, event);
  };
  const handleOnDayMouseEnter = (day, config, event) => {
    onDayMouseEnter(day, {
      ...config,
      DateUtils
    }, event);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "sib-datepicker-container"
  }, /*#__PURE__*/React.createElement(DayPicker, {
    fixedWeeks: true,
    locale: locale,
    month: month,
    selectedDays: selectedDays,
    className: className,
    modifiers: modifiers,
    disabledDays: disabledDays,
    onDayClick: handleDayClick,
    numberOfMonths: numberOfMonths,
    localeUtils: localeUtils,
    showOutsideDays: showOutsideDays,
    navbarElement: DatepickerNavigation,
    onDayMouseEnter: handleOnDayMouseEnter
  }));
}
Datepicker.propTypes = {
  visible: PropTypes.bool,
  locale: PropTypes.string,
  modifiers: PropTypes.shape({}),
  className: PropTypes.string,
  onSelect: PropTypes.func,
  onDayMouseEnter: PropTypes.func,
  numberOfMonths: PropTypes.number,
  showOutsideDays: PropTypes.bool,
  month: PropTypes.instanceOf(Date),
  selectedDays: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.array, PropTypes.func, PropTypes.instanceOf(Date)]),
  disabledDays: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.array, PropTypes.func, PropTypes.instanceOf(Date)])
};
export default Datepicker;